/*!
=========================================================
* 仕入先マスタ
=========================================================
*/
import React from "react";

import {
  Col,
  FormGroup
} from "reactstrap";

import { Link } from 'react-router-dom';
import Request from '../../common/Request';
import InputText from '../FormParts/InputText'
import ButtonWithTooltip from '../FormParts/ButtonWithTooltip';
import CopyToClipWithSpan from '../FormParts/CopyToClipWithSpan';
import WithRole from '../FormParts/ButtonWithRole';
//import ListBase from '../Base/ListBase';
import ListBase from '../Base/ListBaseUnlimit'; // #1168-2021.7.15
import Format from '../../common/Format'
import OpenFaxModal from '../FormParts/OpenFaxModal'
import InputCheckBox from "../FormParts/InputCheckBox";
import FormatCode from "../../common/FormatCode";
import InputDatetime from "../FormParts/InputDatetime";
import CustomTd from "../ViewParts/CustomTd";
/*
*　クラス名：
*     List   ：検索及び一覧表示用クラス
*/
class List extends ListBase {
  /*
  *　関数・変数名：
  *     default_column    ：ReactTable用のデフォルトカラム設定
  *                         下記のdataMapと連動して使う
  *  KEY 説明：
  *     Header            ：タイトル表示用
  *     accessor          ：dataMap関数とのマッピング用の名称
  *     headerClassName   ：テーブルタイトル（TH）用のCSSクラス名
  *     className         ：テーブルデータ（TD）用のCSSクラス名
  *     width             ：初期表示用横サイズ
  *     min-width         ：リサイズ時の最小サイズ
  * 　　nonTargetFilter   ：表示設定に表示しないように設定する　※省略可　
  *                          true -> しない　false ->　する
  * 　　　　　　　　　　　　　　データの固定列を設定する時に利用 
  */

  default_column = [
    { Header: '仕入先ID',accessor: 'SUPPLIER__supplier_natural_id',headerClassName:'text-center',className:'text-left text-top',width:150,minWidth:150},
    { Header: '仕入先名',accessor: 'SUPPLIER__supplier_name',headerClassName:'text-center',className:'text-left text-top',width:250,minWidth:250},
    { Header: '電話番号1',accessor: 'SUPPLIER__supplier_tel',headerClassName:'text-center',className:'text-left text-top',width:200,minWidth:200},
    { Header: '電話番号2',accessor: 'SUPPLIER__supplier_tel2',headerClassName:'text-center',className:'text-left text-top',width:200,minWidth:200},
    { Header: 'FAX番号',accessor: 'SUPPLIER__supplier_fax',headerClassName:'text-center',className:'text-left text-top',width:200,minWidth:200},
    { Header: '適格事業者区分',accessor: 'SUPPLIER__supplier_invoice_business_type',headerClassName:'text-center',className:'text-center text-top',width:200,minWidth:200},
    { Header: '最終仕入済日',accessor: 'SUPPLIER__payment_finish_date',headerClassName:'text-center',className:'text-center text-top',width:200,minWidth:200}
  ];

  /*
  *　関数・変数名：
  *     constructor     　：コンストラクタ関数
  *                         ロード時に1度だけ呼び出される
  *  パラメータ 説明：
  *     props            ：GETやPOSTなどのパラメータ入力値
  */
  constructor(props) {

  /*
  *　関数・変数名：
  *     super     　      ：親のコンストラクターを呼び、thisを使えるようにする
  *  パラメータ 説明：
  *     props            ：GETやPOSTなどのパラメータ入力値
  */
    super(props);

  /*
  *　関数・変数名：
  *     Object.assign    ：stateの初期設定
  *  KEY 説明：（※）は必須
  * 
  *     ▼基本設定
  *     title（※）      ：画面タイトル表示名
  *     add_url          ：新規登録画面のURL設定　
  *                        設定されている場合、自動でボタンが表示
  *     search_url（※） ：検索用APIのURL設定　※検索必須
  * 
  *     ▼画面毎設定　※画面定義より自動実装
  *     SUPPLIER__supplier_name    ：仕入先名
  *     SUPPLIER__supplier_tel     ：仕入先TEL
  * 
  *     ▼共通設定
  * 　　column            ：一覧設定用変数
  *                         タイトルやデータの表示形式を設定
  *                         設定内容は、上記「default_column」を参照
  *     detail_search     ：詳細検索表示設定
  *                         true　→　表示する　false  →　表示しない
  *     valid             ：バリデーションの結果設定
  *                         true　→　正常     false   →　エラー
  * 
  */


  Object.assign(this.state, {
      title: '仕入先マスタ',
      //search_url: '/api/supplier',
      search_url: '/api/supplier/unlimit',
      badge:false,
      SUPPLIER__supplier_name: "",
      SUPPLIER__supplier_tel: "",

      column: this.default_column,
      detail_search:false,
      valid: true,
      searchData:{
        values:{
          show_delete_data : '0'
        },
        errors:{},
        requiredData:{}
      },
      show_detail_search_field:false,
      auto_scroll:true,
      invoice_data_count:0,
      brank_invoice_number_count:0
    });

  /*
  *　関数・変数名：
  *     this.[関数名]    ：this.stateやthis.propsを関数内で利用する場合に設定
  *  構文：
  * 　　this.[関数名] = this.[関数名].bind(this)
  */
    this.validateCallBack = this.validateCallBack.bind(this)
    this.search = this.search.bind(this)
    this.search_count = this.search_count.bind(this)

  /*
  *　関数・変数名：
  *     this.[ダイアログ名]    ：ダイアログ利用時に設定をする
  */
    //this.dialogConfirm = React.createRef();

  }

  componentDidMount(){
    this.search_count(true);
  }

  /*
  *　関数・変数名：
  *     dataMap    ：テーブル表示のデータマッピング関数
  *                    
  *  パラメータ 説明：
  *         data   ： JSON形式の実際のデータ
  *  戻り値 説明：
  *         data   ： JSON形式のマッピング済みデータ
  *                   ※タグや、項目連結定義もここでコンバートする
  */
  dataMap(data) {


    return data.map((prop, key) => {
      let business_type = prop.supplier_invoice_business_type == null? 0:prop.supplier_invoice_business_type
      let supplier_invoice_registration_number = prop.supplier_invoice_registration_number == null? "未登録": prop.supplier_invoice_registration_number
      return {
        id: key,
        SUPPLIER__supplier_natural_id: (<Link target="_blank" to={"/supplier/detail/"+prop.ulid}>{prop.supplier_natural_id}</Link>),
        SUPPLIER__supplier_name: prop.supplier_name,
        SUPPLIER__supplier_tel: (<CopyToClipWithSpan value={Format.phone_number(prop.supplier_tel)} />),
        SUPPLIER__supplier_tel2: (<CopyToClipWithSpan value={Format.phone_number(prop.supplier_tel2)} />),
        SUPPLIER__supplier_fax: (
          <OpenFaxModal
          value={prop.supplier_fax}
          onClick={()=>this.props.faxModal.current.setFaxModal({
            fax_recipient_name:prop.supplier_name+" 御中",
            fax_recipient_number:prop.supplier_fax
          })}
        />),
        SUPPLIER__supplier_invoice_business_type: business_type == 1 ? FormatCode.decode("cst_invoice_business_type",business_type)+"("+supplier_invoice_registration_number+")":FormatCode.decode("cst_invoice_business_type",business_type),
        SUPPLIER__payment_finish_date:prop.payment_finish_date,
      }
    });
  }

  /*
  *　関数・変数名：
  *     search_params    ：検索用パラメータ確認と設定
  *                        データ自体は、Stateより取得
  *   
  *  戻り値 説明：
  *     KEY     ：カラム名
  *     VALUE   ：検索値
  */
  search_params() {
    const {values} = this.state.searchData
    return values&&Object.keys(values).reduce((acc, key)=>{
      if (values[key]){
        acc[key] = values[key]
      }
      return acc
    },{})
  }

  /*
  *　関数・変数名：
  *     search    ：検索実行関数（APIへのリクエストを担当）
  *   
  */
  search() {
    /* ここは開発者が記述 */
    if (!this.validate()) {
        // do nothing
        return;
    }
    this.search_count();
    var searchParmas = this.search_params()
    searchParmas["pager_index"] = "0";
    searchParmas["pager_limit"] = this.state.paging["limit"];
    Request.get(this.state.search_url, 
      searchParmas
      , res => {
        this.setState({
          paging: {
            "index": parseInt(searchParmas["pager_index"]),
            "limit": parseInt(searchParmas["pager_limit"])
          },  
          data: this.dataMap(res.Data)
        });
    })
  }
  /* #1168-2021.7.15 データ件数の取得 */
  search_count(unregist=false) {
    var search_param = this.search_params();
    search_param["data_count"] = 1;
    Request.get(this.state.search_url, search_param, res => {
//        console.log(res.data);
        this.setState({
          data_count: unregist == true ? this.state.data_count :  res.Data["count"],
          invoice_data_count : unregist == false ? this.state.invoice_data_count : res.Data["count_unregist_invoince"],
          brank_invoice_number_count : unregist == false ?this.state.brank_invoice_number_count : res.Data["count_brank_invoice_number"]
        });
    })
  }


  /*
  *　関数・変数名：
  *     validate    ：バリデーションのエラー判定用関数
  *                   エラーがあるか無いかの判定のみ
  *                   バリデーションのチェックは、フォームのコンポーネント側に実装 
  */
  validate() {
    return Object.keys(this.state.searchData.errors).length===0;
  }

  /*
  *　関数・変数名：
  *     handle_[定義名]    ：Inputフォームのイベントを受け取るための関数
  *                         専用コンポーネント（InputTelやInputNumberなど）がない場合に記述する
  *  パラメータ 説明：
  *         e        ：イベント 
  * 
  */
  validateCallBack(newData, callback=()=>{}){
    this.setState({
      searchData:{
        ...this.state.searchData,
        ...newData
      }
    }, ()=>callback())
  }

  /*
  *　関数・変数名：
  *     search_field_cols   ：検索フォーム用フィールドを表示するための関数
  */
  search_field_cols() {
    return (
      <>
        <Col md="4">
          <InputText label="仕入先ID"
            name="SUPPLIER__supplier_natural_id"
            labelOn={true}
            validateCallback={this.validateCallBack}
            enterCallback={this.searchWithPageIndex}
            rootData={this.state.searchData}
            validateType={"search"}
            enterSearchFlag={true} />
        </Col>
        <Col md="4">
          <InputText label="仕入先名"
                     name="SUPPLIER__supplier_name"
                     labelOn={true} 
                     validateCallback={this.validateCallBack} 
                     enterCallback={this.searchWithPageIndex}
                     rootData={this.state.searchData}
                     validateType={"search"}
                     enterSearchFlag={true} />
        </Col>
        <Col md="4">
          <InputText label="電話番号" 
                     name="SUPPLIER__supplier_tel" 
                     labelOn={true} 
                     validateCallback={this.validateCallBack} 
                     validateType={"search"} 
                     enterCallback={this.searchWithPageIndex} 
                     rootData={this.state.searchData}
                     enterSearchFlag={true} />
        </Col>
        <Col md="2">
          <InputCheckBox
            label='削除データも表示'
            name='NODB__show_delete_data'
            labelOn={false}
            checkedValue={'1'}
            uncheckedValue={'0'}
            validateCallback={this.validateCallBack}
            rootData={this.state.searchData}
            validateType={"search"} 
          />
        </Col>
        <Col md="2">
          {"適格事業者未登録件数："+this.state.invoice_data_count+"件"}<br />
          {"適格事業者かつ番号未登録の件数："+this.state.brank_invoice_number_count+"件"}
        </Col>
        <Col md="4">
          <FormGroup>
            <InputDatetime
              label='最終仕入済日（FROM）'
              name='SUPPLIER__payment_finish_date_from'
              labelOn={true}
              validateCallback={this.validateCallBack}
              rootData={this.state.searchData}
              validateType={'search'}
            />
          </FormGroup>
        </Col>
        <Col md="4">
          <FormGroup>
            <InputDatetime
              label='最終仕入済日（TO）'
              name='SUPPLIER__payment_finish_date_to'
              labelOn={true}
              validateCallback={this.validateCallBack}
              rootData={this.state.searchData}
              validateType={'search'}
            />
          </FormGroup>
        </Col>
        <Col md="4">
        <CustomTd 
          label="適格事業者区分：" 
          colSpan="4"
          copy={false}
          value={<>
            <InputCheckBox
              label='適格事業者'
              name='NODB__invoice_business_type_1'
              labelOn={false}
              checkedValue={'1'}
              uncheckedValue={'0'}
              validateCallback={this.validateCallBack}
              rootData={this.state.searchData}
              validateType={"search"} 
            />
            <InputCheckBox
              label='免税'
              name='NODB__invoice_business_type_2'
              labelOn={false}
              checkedValue={'1'}
              uncheckedValue={'0'}
              validateCallback={this.validateCallBack}
              rootData={this.state.searchData}
              validateType={"search"} 
            />
            <InputCheckBox
              label='未確認'
              name='NODB__invoice_business_type_0'
              labelOn={false}
              checkedValue={'1'}
              uncheckedValue={'0'}
              validateCallback={this.validateCallBack}
              rootData={this.state.searchData}
              validateType={"search"} 
            />
            <InputCheckBox
              label='適格事業者かつ番号未登録'
              name='NODB__invoice_business_type_9'
              labelOn={false}
              checkedValue={'1'}
              uncheckedValue={'0'}
              validateCallback={this.validateCallBack}
              rootData={this.state.searchData}
              validateType={"search"} 
            />
          </>}
        />
        </Col>
      </>
    );
  }

  /*
  *　関数・変数名：
  *     add_field_cols   ：新規登録ボタン以外を表示するための関数
  *                        表示箇所は、新規登録ボタンの直後
  *                        ※新規登録ボタンは、add_urlを記述で自動表示
  *                        ※省略可
  */
  add_field_cols() {
    const ButtonWithTooltipWithRole = WithRole(ButtonWithTooltip, this.props.buttons)
    return (
      <>
        <Col md="6">
          <ButtonWithTooltipWithRole
              button_id="BTN_M2_01_04200"
              onclick={() => { this.props.history.push('/supplier/add/') }}
              class="float-right btn-search btn-facebook"
              id="tmp"
              icon="fas fa-plus"
              label="追加"
              message="データを追加"
          />
        </Col>
      </>
    );
  }

  /*
  *　関数・変数名：
  *     detail_search_field_btn   ：詳細検索用ボタンを表示するための関数
  *                                 ※省略可
  */
  detail_search_field_btn(){
      return (<></>);
  }

  /*
  *　関数・変数名：
  *     detail_search_field_cols   ：詳細検索用フィールドを表示するための関数
  *                                  ※省略可
  */
  detail_search_field_cols(){
      return (<></>);
  }

  /*
  *　関数・変数名：
  *     checkbox_field_cols   ：一覧の下にSELECTやCheckboxを表示するための関数
  *                             ※省略可
  */
  checkbox_field_cols(){
    return (
      <></>
    );
  }  

  /*
  *　関数・変数名：
  *     dialog_defines        ：ダイアログを表示設定をするための関数
  *                             ※省略可
  * 設定方法：
  *   1）ダイアログ用コンポーネントを設定
  * 　  ※ソースの最上部、import区に追加
  *     import DialogBase from '../Base/DialogBase';
  *   2）コンストラクタへ追加
  *   ※this.[任意のダイアログ名] = React.createRef();
  * 　  this.dialogConfirm = React.createRef();
  *   3）dialog_defines内でダイアログを呼び出す
  *     <DialogConfirm ref={this.dialogConfirm} />
  * 
  *   ※パラメータの設定方法
  *     スペースを開けて、追記していく
  *     <DialogConfirm ref={this.dialogConfirm} title={this.state.title} default_footer={true} />
  * 　　その他、設定パラメータ
  *          title　:　ダイアログタイトル
  *          size   : ダイアログサイズ
  *          default_footer   ： 初期フッターの表示有無
  *          positive         ：「はい」「OK」などの表示有無
  *          newtral          ：「はい」「いいえ」などの 間に表示するボタンの表示有無 
  *          negative         ：「いいえ」「キャンセル」などの表示有無
  *          class            ：CSS用Class設定
  *          positive_label   ：ラベル　初期は「はい」
  *          newtral_label    ：ラベル　初期は「キャンセル」
  *          negative_label   ：ラベル　初期は「いいえ」
  */
  dialog_defines() {
    return (
      <>
      {/*<DialogConfirm ref={this.dialogConfirm} />*/}
      </>
    );
  } 

}

export default List;
  /*
  *　クラス名：
  *     DialogConfirm   ：クラス名自体はダイアログの任意の名前
  */
/*  
 class DialogConfirm extends DialogBase {
  constructor(props) {
    super(props);

    Object.assign(this.state, {
      title: 'タイトル',
    });
  }

  /*
  *　クラス名：
  *     componentDidUpdate   ：propsの値をチェックするための関数
  *                            変更されたら、Stateに設定する。
  * 詳細は下記URLチェック
  * https://ja.reactjs.org/docs/react-component.html#componentdidupdate
  *
  */
/*
  componentDidUpdate(prevProps) {
    if (prevProps.title !== this.props.title){
      this.setState({title:this.props.title});
    }
  }

  bodyContent() {
    return (
      <>
      <textarea style={{width: "100%"}} name="example" rows="5" placeholder="差戻メッセージを入力してください。"></textarea>
      </>
    );
  }
}


*/